import { DynamicStyleSheet, variants } from '@pulsar/core';

export default DynamicStyleSheet.create(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...variants([
      {
        primary: {
          backgroundColor: theme.colors.counterPrimaryBG,
        },
        secondary: {
          backgroundColor: theme.colors.counterSecondaryBG,
        },
        prominent: {
          backgroundColor: theme.colors.counterProminentBG,
        },
      },
      {
        prop: 'size',
        variants: {
          m: {
            height: 24,
            minWidth: 24,
            borderRadius: 12,
          },
          s: {
            height: 18,
            minWidth: 18,
            borderRadius: 9,
          },
          xs: {
            height: 12,
            width: 12,
            borderRadius: 6,
            backgroundColor: 'rgba(0, 0, 0, .0)',
          },
        },
      },
    ]),
  },
  content: {
    ...variants([
      {
        primary: {
          color: theme.colors.counterPrimaryText,
        },
        secondary: {
          color: theme.colors.counterSecondaryText,
        },
        prominent: {
          color: theme.colors.counterProminentText,
        },
      },
      {
        prop: 'size',
        variants: {
          m: {
            fontSize: theme.fontSizes[1],
            lineHeight: theme.fontSizes[1],
            fontWeight: '500',
          },
          s: {
            fontSize: theme.fontSizes[0],
            lineHeight: theme.fontSizes[0],
          },
        },
      },
    ]),
  },
  badge: {
    width: 6,
    height: 6,
    borderRadius: 3,
    ...variants({
      primary: {
        backgroundColor: theme.colors.counterPrimaryBG,
      },
      secondary: {
        backgroundColor: theme.colors.counterSecondaryBG,
      },
      prominent: {
        backgroundColor: theme.colors.counterProminentBG,
      },
    }),
  },
}));
